import React from 'react';

const BeforeAfter4 = (props) => {
  const containerStyle = {
    fontFamily: 'Arial, sans-serif',
    padding: '20px',
    textAlign: 'center',
  };

  const titleStyle = {
    fontSize: '2rem',
    marginBottom: '20px',
  };

  const comparisonContainerStyle = {
    display: 'flex',
    justifyContent: 'center',
    overflow: 'hidden',
    boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
    position: 'relative',
  };

  const beforeStackStyle = {
    display: 'flex',
    flexDirection: 'column',
    width: '300px',
    position: 'relative',
  };

  const beforeImageStyle = {
    flex: 1,
    width: '100%',
    height: '50%',
    objectFit: 'cover',
  };

  const afterRowStyle = {
    display: 'flex',
    position: 'relative',
  };

  const afterImageWrapperStyle = {
    flex: 1,
  };

  const imageStyle = {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  };

  const labelStyle = {
    position: 'absolute',
    padding: '8px 15px',
    background: 'rgba(0, 0, 0, 0.7)',
    color: 'white',
    fontWeight: 'bold',
    borderRadius: '4px',
    zIndex: 2,
  };

  const labelBeforeStyle = {
    ...labelStyle,
    bottom: '15px',
    left: '15px',
  };

  const labelAfterStyle = {
    ...labelStyle,
    bottom: '15px',
    right: '15px',
  };

  return (
        <div className="project-card">
                    <div className="project-title">
      <h2 >{props.title}</h2></div>
      <div style={comparisonContainerStyle}>
        {/* BEFORE - 2 stacked images */}
        <div style={beforeStackStyle}>
          <img src={props.i1} alt="Before 1" style={beforeImageStyle} />
          <img src={props.i2} alt="Before 2" style={beforeImageStyle} />
        <div className="label before">Avant</div>
        </div>

        {/* AFTER - 3 images in a row */}
        <div style={beforeStackStyle}>
          {[props.i3, props.i4].map((src, idx) => (
            <div style={afterImageWrapperStyle} key={idx}>
              <img src={src} alt={`After ${idx + 1}`} style={imageStyle} />
            </div>
          ))}
        <div className="label after">Après</div>        </div>
      </div>
    </div>
  );
};

export default BeforeAfter4;
